import { useState } from "react";
import axios from "axios";
import { Send, Check } from "lucide-react";
import { SiteLayout, PageHero } from "../components/site";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const field = "w-full rounded-2xl border border-[#3F4A3C]/15 bg-white px-5 py-3.5 font-jakarta text-sm text-[#3F4A3C] placeholder:text-[#5E6B57] focus:outline-none focus:border-[#C59B45] transition-colors";

const SubscribeForm = () => {
  const [f, setF] = useState({ name: "", email: "", website: "" });
  const [state, setState] = useState("idle");
  const [error, setError] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setState("sending"); setError("");
    try {
      await axios.post(`${API}/newsletter`, f);
      setState("done");
    } catch (err) {
      setState("idle");
      setError(err?.response?.status === 422 ? "Please enter a valid email address." : (err?.response?.data?.detail || "Something went wrong. Please try again."));
    }
  };
  if (state === "done") {
    return <p className="flex items-start gap-3 rounded-[24px] bg-[#E3E9E4] px-6 py-5 font-jakarta text-sm text-[#3F4A3C]" data-testid="newsletter-success"><Check className="w-5 h-5 text-[#1F4D3A] shrink-0" />Thank you for subscribing. You'll hear from us soon.</p>;
  }
  return (
    <form onSubmit={submit} className="grid gap-4" data-testid="newsletter-form">
      <input value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} placeholder="First name (optional)" aria-label="First name" maxLength={120} className={field} data-testid="newsletter-name" />
      <input type="email" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} placeholder="Email address" aria-label="Email address" className={field} data-testid="newsletter-email" />
      <input tabIndex={-1} autoComplete="off" value={f.website} onChange={(e) => setF({ ...f, website: e.target.value })} className="hidden" aria-hidden />
      {error && <p className="font-jakarta text-sm text-[#9A3B2E]" data-testid="newsletter-error">{error}</p>}
      <button type="submit" disabled={state === "sending"} data-testid="newsletter-submit" className="inline-flex items-center justify-center gap-2 rounded-full bg-[#1F4D3A] px-7 py-3.5 font-jakarta text-sm text-[#F6F2E9] hover:bg-[#2C6B50] disabled:opacity-60 transition-colors">
        <Send className="w-4 h-4" />{state === "sending" ? "Subscribing…" : "Subscribe"}
      </button>
      <p className="font-jakarta text-xs text-[#4A4F45]">We'll only use your email to send our newsletter. You can unsubscribe at any time.</p>
    </form>
  );
};

export default function Newsletter() {
  return (
    <SiteLayout testid="newsletter-page">
      <PageHero eyebrow="Newsletter" lines={["Stay in touch."]} sub="News, upcoming programs and wellbeing tips from the Inner You Development team." />
      <section className="max-w-[1360px] mx-auto px-5 sm:px-10 pb-24">
        <div className="max-w-xl rounded-[32px] bg-white border border-[#3F4A3C]/10 p-6 sm:p-10">
          <SubscribeForm />
        </div>
      </section>
    </SiteLayout>
  );
}
